// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"tL9oq2"};